/**
 * @generated SignedSource<<11f75da1f6b1f13f7a83e3ec89117670>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserRole = "ADMIN" | "INVALID" | "USER";
export type UserContext_GetUserByEmailQuery$variables = {
  email: string;
};
export type UserContext_GetUserByEmailQuery$data = {
  readonly users: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly email: string;
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly internal: boolean;
        readonly lastName: string | null | undefined;
        readonly role: UserRole | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
};
export type UserContext_GetUserByEmailQuery = {
  response: UserContext_GetUserByEmailQuery$data;
  variables: UserContext_GetUserByEmailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "UserConnection",
    "kind": "LinkedField",
    "name": "users",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserContext_GetUserByEmailQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserContext_GetUserByEmailQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "067fbde54e33ae0b3e3c2b0c6ccd01a2",
    "id": null,
    "metadata": {},
    "name": "UserContext_GetUserByEmailQuery",
    "operationKind": "query",
    "text": "query UserContext_GetUserByEmailQuery(\n  $email: String!\n) {\n  users(where: {email: $email}) {\n    edges {\n      node {\n        id\n        email\n        firstName\n        lastName\n        internal\n        role\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef2fb2f95fc7437d8d5f583895a67151";

export default node;
